module.exports = __webpack_public_path__ + "img/6528f2d969cb38eedfbe9d7e3089a20e.png";